import { fetchWithRetry } from '../RetryFetch'

export const getIndustryTypeList = async () => {
	const options = {
		method: 'GET',
		mode: 'cors',
		headers: {
			'Content-Type': 'application/json',
		}
	}

	return await fetchWithRetry(`${process.env.REACT_APP_API}/search/industrytype`, options)
		.then(response => {
			if (response.ok) {
				return response.json();
			}
			throw new Error('Error when requesting data from the server, wait a few moments and refresh the page!');
		})

};

